import { Vector2, Vector3 } from 'three';

export class SwizzleExtension {
    // 3D to 2D
    static XX(v: Vector3 | Vector2): Vector2 {
        return new Vector2(v.x, v.x);
    }

    // static XY(v: Vector3): Vector2;
    // static XY(v: Vector2): Vector2;
    // static XY(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.x, v.y);
    // }

    static XZ(v: Vector3): Vector2 {
        return new Vector2(v.x, v.z);
    }

    // static YX(v: Vector3): Vector2;
    // static YX(v: Vector2): Vector2;
    // static YX(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.y, v.x);
    // }

    // static YY(v: Vector3): Vector2;
    // static YY(v: Vector2): Vector2;
    // static YY(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.y, v.y);
    // }

    // static YZ(v: Vector3): Vector2;
    // static YZ(v: Vector2): Vector2;
    // static YZ(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.y, v.z);
    // }

    // static ZX(v: Vector3): Vector2;
    // static ZX(v: Vector2): Vector2;
    // static ZX(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.z, v.x);
    // }

    // static ZY(v: Vector3): Vector2;
    // static ZY(v: Vector2): Vector2;
    // static ZY(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.z, v.y);
    // }

    // static ZZ(v: Vector3): Vector2;
    // static ZZ(v: Vector2): Vector2;
    // static ZZ(v: Vector3 | Vector2): Vector2 {
    //     return new Vector2(v.z, v.z);
    // }

    // // 3D to 3D
    // static XXX(v: Vector3): Vector3;
    // static XXX(v: Vector2): Vector3;
    // static XXX(v: Vector3 | Vector2): Vector3 {
    //     return new Vector3(v.x, v.x, v.x);
    // }

    // static XXY(v: Vector3): Vector3;
    // static XXY(v: Vector2): Vector3;
    // static XXY(v: Vector3 | Vector2): Vector3 {
    //     return new Vector3(v.x, v.x, v.y);
    // }

    // // and so on for the other combinations...

    // // 2D to 3D
    // static XXX(v: Vector2): Vector3 {
    //     return new Vector3(v.x, v.x, v.x);
    // }

    // static XXY(v: Vector2): Vector3 {
    //     return new Vector3(v.x, v.x, v.y);
    // }

    // // and so on for the other combinations...

    // // 2D to 2D
    // static XX(v: Vector2): Vector2;
    // static XX(v: Vector3): Vector2;
    // static XX(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.x, v.x);
    // }

    // static XY(v: Vector2): Vector2;
    // static XY(v: Vector3): Vector2;
    // static XY(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.x, v.y);
    // }

    // // 2D to 2D
    // static YX(v: Vector2): Vector2;
    // static YX(v: Vector3): Vector2;
    // static YX(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.y, v.x);
    // }

    // static YY(v: Vector2): Vector2;
    // static YY(v: Vector3): Vector2;
    // static YY(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.y, v.y);
    // }

    // static YZ(v: Vector2): Vector2;
    // static YZ(v: Vector3): Vector2;
    // static YZ(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.y, v.z);
    // }

    // static ZX(v: Vector2): Vector2;
    // static ZX(v: Vector3): Vector2;
    // static ZX(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.z, v.x);
    // }

    // static ZY(v: Vector2): Vector2;
    // static ZY(v: Vector3): Vector2;
    // static ZY(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.z, v.y);
    // }

    // static ZZ(v: Vector2): Vector2;
    // static ZZ(v: Vector3): Vector2;
    // static ZZ(v: Vector2 | Vector3): Vector2 {
    //     return new Vector2(v.z, v.z);
    // }
}
